import {useTranslation} from 'react-i18next';
import {bounceMessage} from '../../../layout/userMessages/UserMessage';
import {suspendedConfirmation} from '../../../redux/event/eventActions';

export function useTicketValidation() {
    const {t} = useTranslation('suspendedConfirmation');

    const validateTickets = (selectedTickets: any[]) => {
        const ticketCounts: Record<string, { extra: number; ticket: number }> = {};
        
        selectedTickets.forEach(ticketObj => {
            if(ticketObj.limitByTickets === 1 && ticketObj.tid) {
                if(!ticketCounts[ticketObj.tid]) {
                    ticketCounts[ticketObj.tid] = {extra: 0, ticket: 0};
                }
            }
        });
        
        Object.keys(ticketCounts).forEach(tid => {
            const extraTickets = selectedTickets.filter(ticketObj => 
                ticketObj.type === 'extra' && String(ticketObj.tid) === tid
            );
            ticketCounts[tid].extra = extraTickets.length;
            
            const regularTickets = selectedTickets.filter(ticketObj => 
                ticketObj.type === 'ticket' && String(ticketObj.id) === tid
            );
            ticketCounts[tid].ticket = regularTickets.length;
        });
        
        const hasMoreExtras = Object.values(ticketCounts).some(counts => counts.extra > counts.ticket);
        if(hasMoreExtras) {
            bounceMessage(t('moreExtrasThanTickets'), 'warning');
            return false;
        }
        
        return true;
    };

    const handleConfirmation = async (token: string | undefined, selectedTickets: any[], onResponse?: (res: any) => void) => {
        if(!validateTickets(selectedTickets)) {
            return;
        }
        
        if(token) {
            const qids = selectedTickets.map(ticket => ticket.qid);
            const res = await suspendedConfirmation(token, {qids});
            if(onResponse) {
                onResponse(res);
            } else {
                console.log('Response:', res);
            }
           
        }
    };

    return {validateTickets, handleConfirmation};
} 